"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrlColorRuleParamIndex = exports.ErrlDpiExistRuleParamIndex = exports.ErrlDpiRuleParamIndex = exports.RecipientRuleParamIndex = exports.DateRuleParamIndex = exports.DetailAmountRuleParamIndex = exports.DetailVerticalRuleParamIndex = exports.DetailHorizontalRuleParamIndex = exports.StampRuleParamIndex = exports.RobotaRuleParamIndex = exports.VerificationRuleParamIndex = exports.BudgetRuleParamIndex = exports.NightRuleParamIndex = exports.PurchaseAmountRuleParamIndex = exports.PartnerBankRuleParamIndex = exports.PartnerAddressRuleParamIndex = exports.PartnerTelRuleParamIndex = exports.PartnerExistRuleParamIndex = exports.DuplicateRuleParamIndex = exports.AmountRuleParamIndex = exports.LengthRuleParamIndex = exports.FillRuleParamIndex = exports.RuleGroup = exports.RuleType = void 0;
var RuleType;
(function (RuleType) {
    RuleType["DEFAULT"] = "default";
    RuleType["FILLED"] = "filled";
    RuleType["LENGTH"] = "length";
    RuleType["AMOUNT"] = "amount";
    RuleType["BUDGET"] = "budget";
    RuleType["DUPLICATE"] = "duplicate";
    RuleType["NIGHT"] = "night";
    RuleType["PARTNER_EXIST"] = "partnerExist";
    RuleType["PARTNER_NOT_EXIST"] = "partnerNotExist";
    RuleType["PARTNER_TEL_MATCH"] = "partnerTelMatch";
    RuleType["PARTNER_TEL_NOT_MATCH"] = "partnerTelNotMatch";
    RuleType["PARTNER_ADDRESS_MATCH"] = "partnerAddressMatch";
    RuleType["PARTNER_ADDRESS_NOT_MATCH"] = "partnerAddressNotMatch";
    RuleType["PARTNER_BANK_MATCH"] = "partnerBankMatch";
    RuleType["PARTNER_BANK_NOT_MATCH"] = "partnerTelBankMatch";
    RuleType["PURCHASE_AMOUNT"] = "purchaseAmount";
    RuleType["VERIFICATION_AMOUNT_TRUE"] = "verificationAmountTrue";
    RuleType["VERIFICATION_AMOUNT_FALSE"] = "verificationAmountFalse";
    RuleType["ROBOTA"] = "robota";
    RuleType["EXPORT"] = "export";
    RuleType["STAMP_EXIST"] = "stampExist";
    RuleType["STAMP_NOT_EXIST"] = "stampNotExist";
    RuleType["DETAIL_HORIZONTAL"] = "detailHorizontal";
    RuleType["DETAIL_HORIZONTAL_MATCH"] = "detailHorizontalMatch";
    RuleType["DETAIL_VERTICAL"] = "detailVertical";
    RuleType["DETAIL_VERTICAL_MATCH"] = "detailVerticalMatch";
    RuleType["DETAIL_AMOUNT"] = "detailAmount";
    RuleType["DETAIL_AMOUNT_MATCH"] = "detailAmountMatch";
    RuleType["DATE_AFTER"] = "dateAfter";
    RuleType["DATE_BEFORE"] = "dateBefore";
    RuleType["RECIPIENT_EXIST"] = "recipientExist";
    RuleType["RECIPIENT_NOT_EXIST"] = "recipientNotExist";
    RuleType["ERRL_DPI"] = "errlDpi";
    RuleType["ERRL_DPI_EXIST"] = "errlDpiExist";
    RuleType["ERRL_COLOR"] = "errlColor";
    RuleType["DUMMY"] = "dummy";
    RuleType["CUSTOM_EXCHANGE"] = "customExchange";
    RuleType["AMOUNT_ACCOUNTS"] = "amountAccounts";
    RuleType["TAX_ACCOUNTS"] = "taxAccounts";
})(RuleType = exports.RuleType || (exports.RuleType = {}));
var RuleGroup;
(function (RuleGroup) {
    RuleGroup["DEFAULT"] = "default";
    RuleGroup["FILLED"] = "filled";
    RuleGroup["LENGTH"] = "length";
    RuleGroup["AMOUNT"] = "amount";
    RuleGroup["BUDGET"] = "budget";
    RuleGroup["DUPLICATE"] = "duplicate";
    RuleGroup["NIGHT"] = "night";
    RuleGroup["PARTNER"] = "partner";
    RuleGroup["PURCHASE_AMOUNT"] = "purchaseAmount";
    RuleGroup["VERIFICATION"] = "verification";
    RuleGroup["ROBOTA"] = "robota";
    RuleGroup["EXPORT"] = "export";
    RuleGroup["STAMP"] = "stamp";
    RuleGroup["DETAIL_HORIZONTAL"] = "detailHorizontal";
    RuleGroup["DETAIL_HORIZONTAL_MATCH"] = "detailHorizontalMatch";
    RuleGroup["DETAIL_VERTICAL"] = "detailVertical";
    RuleGroup["DETAIL_VERTICAL_MATCH"] = "detailVerticalMatch";
    RuleGroup["DETAIL_AMOUNT"] = "detailAmount";
    RuleGroup["DETAIL_AMOUNT_MATCH"] = "detailAmountMatch";
    RuleGroup["DATE"] = "date";
    RuleGroup["RECIPIENT"] = "recipient";
    RuleGroup["AMOUNT_ACCOUNTS"] = "amountAccounts";
    RuleGroup["TAX_ACCOUNTS"] = "taxAccounts";
    RuleGroup["ERRL_DPI"] = "errlDpi";
    RuleGroup["ERRL_DPI_EXIST"] = "errlDpiExist";
    RuleGroup["ERRL_COLOR"] = "errlColor";
    RuleGroup["CUSTOM_EXCHANGE"] = "customExchange";
    RuleGroup["DUMMY"] = "dummy";
})(RuleGroup = exports.RuleGroup || (exports.RuleGroup = {}));
/** 入力チェックのパラメータのIndex */
var FillRuleParamIndex;
(function (FillRuleParamIndex) {
    FillRuleParamIndex[FillRuleParamIndex["COLUMNS"] = 0] = "COLUMNS";
})(FillRuleParamIndex = exports.FillRuleParamIndex || (exports.FillRuleParamIndex = {}));
/** 文字数チェックのパラメータのIndex */
var LengthRuleParamIndex;
(function (LengthRuleParamIndex) {
    LengthRuleParamIndex[LengthRuleParamIndex["COLUMNS"] = 0] = "COLUMNS";
    LengthRuleParamIndex[LengthRuleParamIndex["LENGTH"] = 1] = "LENGTH";
})(LengthRuleParamIndex = exports.LengthRuleParamIndex || (exports.LengthRuleParamIndex = {}));
/** 金額チェックのパラメータのIndex */
var AmountRuleParamIndex;
(function (AmountRuleParamIndex) {
    AmountRuleParamIndex[AmountRuleParamIndex["COLUMN"] = 0] = "COLUMN";
    AmountRuleParamIndex[AmountRuleParamIndex["AMOUNT"] = 1] = "AMOUNT";
})(AmountRuleParamIndex = exports.AmountRuleParamIndex || (exports.AmountRuleParamIndex = {}));
/** 重複チェックのパラメータのIndex */
var DuplicateRuleParamIndex;
(function (DuplicateRuleParamIndex) {
    DuplicateRuleParamIndex[DuplicateRuleParamIndex["COLUMNS"] = 0] = "COLUMNS";
    DuplicateRuleParamIndex[DuplicateRuleParamIndex["VOUCHER_STATUSES"] = 1] = "VOUCHER_STATUSES";
})(DuplicateRuleParamIndex = exports.DuplicateRuleParamIndex || (exports.DuplicateRuleParamIndex = {}));
/** 取引先存在チェックのパラメータのIndex */
var PartnerExistRuleParamIndex;
(function (PartnerExistRuleParamIndex) {
    PartnerExistRuleParamIndex[PartnerExistRuleParamIndex["NAME"] = 0] = "NAME";
    PartnerExistRuleParamIndex[PartnerExistRuleParamIndex["COLUMNS"] = 1] = "COLUMNS";
})(PartnerExistRuleParamIndex = exports.PartnerExistRuleParamIndex || (exports.PartnerExistRuleParamIndex = {}));
/** 取引先電話番号チェックのパラメータのIndex */
var PartnerTelRuleParamIndex;
(function (PartnerTelRuleParamIndex) {
    PartnerTelRuleParamIndex[PartnerTelRuleParamIndex["COLUMN"] = 0] = "COLUMN";
})(PartnerTelRuleParamIndex = exports.PartnerTelRuleParamIndex || (exports.PartnerTelRuleParamIndex = {}));
/** 取引先住所チェックのパラメータのIndex */
var PartnerAddressRuleParamIndex;
(function (PartnerAddressRuleParamIndex) {
    PartnerAddressRuleParamIndex[PartnerAddressRuleParamIndex["COLUMN"] = 0] = "COLUMN";
})(PartnerAddressRuleParamIndex = exports.PartnerAddressRuleParamIndex || (exports.PartnerAddressRuleParamIndex = {}));
/** 取引先銀行チェックのパラメータのIndex */
var PartnerBankRuleParamIndex;
(function (PartnerBankRuleParamIndex) {
    PartnerBankRuleParamIndex[PartnerBankRuleParamIndex["NAME_COLUMN"] = 0] = "NAME_COLUMN";
    PartnerBankRuleParamIndex[PartnerBankRuleParamIndex["BRANCH_NAME_COLUMN"] = 1] = "BRANCH_NAME_COLUMN";
    PartnerBankRuleParamIndex[PartnerBankRuleParamIndex["ACCOUNT_TYPE_COLUMN"] = 2] = "ACCOUNT_TYPE_COLUMN";
    PartnerBankRuleParamIndex[PartnerBankRuleParamIndex["ACCOUNT_NUMBER_COLUMN"] = 3] = "ACCOUNT_NUMBER_COLUMN";
})(PartnerBankRuleParamIndex = exports.PartnerBankRuleParamIndex || (exports.PartnerBankRuleParamIndex = {}));
/** 買上金額チェックのパラメーターのIndex */
var PurchaseAmountRuleParamIndex;
(function (PurchaseAmountRuleParamIndex) {
    PurchaseAmountRuleParamIndex[PurchaseAmountRuleParamIndex["AMOUNT_COLUMN"] = 0] = "AMOUNT_COLUMN";
    PurchaseAmountRuleParamIndex[PurchaseAmountRuleParamIndex["PURCHASE_AMOUNT_COLUMN"] = 1] = "PURCHASE_AMOUNT_COLUMN";
})(PurchaseAmountRuleParamIndex = exports.PurchaseAmountRuleParamIndex || (exports.PurchaseAmountRuleParamIndex = {}));
var NightRuleParamIndex;
(function (NightRuleParamIndex) {
    NightRuleParamIndex[NightRuleParamIndex["NAME_COLUMN"] = 0] = "NAME_COLUMN";
    NightRuleParamIndex[NightRuleParamIndex["TEL_COLUMN"] = 1] = "TEL_COLUMN";
    NightRuleParamIndex[NightRuleParamIndex["ADDRESS_COLUMN"] = 2] = "ADDRESS_COLUMN";
    NightRuleParamIndex[NightRuleParamIndex["WHITE_CATEGORIES"] = 3] = "WHITE_CATEGORIES";
})(NightRuleParamIndex = exports.NightRuleParamIndex || (exports.NightRuleParamIndex = {}));
var BudgetRuleParamIndex;
(function (BudgetRuleParamIndex) {
    BudgetRuleParamIndex[BudgetRuleParamIndex["NAME_COLUMN"] = 0] = "NAME_COLUMN";
    BudgetRuleParamIndex[BudgetRuleParamIndex["TEL_COLUMN"] = 1] = "TEL_COLUMN";
    BudgetRuleParamIndex[BudgetRuleParamIndex["ADDRESS_COLUMN"] = 2] = "ADDRESS_COLUMN";
    BudgetRuleParamIndex[BudgetRuleParamIndex["AMOUNT_COLUMN"] = 3] = "AMOUNT_COLUMN";
    BudgetRuleParamIndex[BudgetRuleParamIndex["PERCENT"] = 4] = "PERCENT";
})(BudgetRuleParamIndex = exports.BudgetRuleParamIndex || (exports.BudgetRuleParamIndex = {}));
var VerificationRuleParamIndex;
(function (VerificationRuleParamIndex) {
    VerificationRuleParamIndex[VerificationRuleParamIndex["FLAG"] = 0] = "FLAG";
    VerificationRuleParamIndex[VerificationRuleParamIndex["VERIFICATION_COLUMN"] = 1] = "VERIFICATION_COLUMN";
    VerificationRuleParamIndex[VerificationRuleParamIndex["TARGET_COLUMNS"] = 2] = "TARGET_COLUMNS";
})(VerificationRuleParamIndex = exports.VerificationRuleParamIndex || (exports.VerificationRuleParamIndex = {}));
/** ロボタのエラーチェックのパラメータのIndex */
var RobotaRuleParamIndex;
(function (RobotaRuleParamIndex) {
    RobotaRuleParamIndex[RobotaRuleParamIndex["COLUMNS"] = 0] = "COLUMNS";
})(RobotaRuleParamIndex = exports.RobotaRuleParamIndex || (exports.RobotaRuleParamIndex = {}));
/** 押印チェックのパラメータのIndex */
var StampRuleParamIndex;
(function (StampRuleParamIndex) {
    StampRuleParamIndex[StampRuleParamIndex["COLUMN"] = 0] = "COLUMN";
})(StampRuleParamIndex = exports.StampRuleParamIndex || (exports.StampRuleParamIndex = {}));
/** 詳細の横計チェックのパラメータのIndex */
var DetailHorizontalRuleParamIndex;
(function (DetailHorizontalRuleParamIndex) {
    DetailHorizontalRuleParamIndex[DetailHorizontalRuleParamIndex["UNIT_PRICE_COLUMN"] = 0] = "UNIT_PRICE_COLUMN";
    DetailHorizontalRuleParamIndex[DetailHorizontalRuleParamIndex["QUANTITY_COLUMN"] = 1] = "QUANTITY_COLUMN";
    DetailHorizontalRuleParamIndex[DetailHorizontalRuleParamIndex["SUB_TOTAL_COLUMN"] = 2] = "SUB_TOTAL_COLUMN";
    // TODO: 税額や税率？
})(DetailHorizontalRuleParamIndex = exports.DetailHorizontalRuleParamIndex || (exports.DetailHorizontalRuleParamIndex = {}));
var DetailVerticalRuleParamIndex;
(function (DetailVerticalRuleParamIndex) {
    DetailVerticalRuleParamIndex[DetailVerticalRuleParamIndex["SUB_TOTAL_COLUMN"] = 0] = "SUB_TOTAL_COLUMN";
    DetailVerticalRuleParamIndex[DetailVerticalRuleParamIndex["TOTAL_PRICE_COLUMN"] = 1] = "TOTAL_PRICE_COLUMN";
    // TODO: 税額や税率？
})(DetailVerticalRuleParamIndex = exports.DetailVerticalRuleParamIndex || (exports.DetailVerticalRuleParamIndex = {}));
var DetailAmountRuleParamIndex;
(function (DetailAmountRuleParamIndex) {
    DetailAmountRuleParamIndex[DetailAmountRuleParamIndex["AMOUNT_COLUMN"] = 0] = "AMOUNT_COLUMN";
    DetailAmountRuleParamIndex[DetailAmountRuleParamIndex["AMOUNT_TAX_EXCLUDED_COLUMN"] = 1] = "AMOUNT_TAX_EXCLUDED_COLUMN";
    DetailAmountRuleParamIndex[DetailAmountRuleParamIndex["TAX_COLUMN"] = 2] = "TAX_COLUMN";
})(DetailAmountRuleParamIndex = exports.DetailAmountRuleParamIndex || (exports.DetailAmountRuleParamIndex = {}));
/** 日付チェックのパラメータのIndex */
var DateRuleParamIndex;
(function (DateRuleParamIndex) {
    DateRuleParamIndex[DateRuleParamIndex["COLUMN"] = 0] = "COLUMN";
    DateRuleParamIndex[DateRuleParamIndex["DATE_SPAN"] = 1] = "DATE_SPAN";
})(DateRuleParamIndex = exports.DateRuleParamIndex || (exports.DateRuleParamIndex = {}));
/** 宛名チェックのパラメータのIndex */
var RecipientRuleParamIndex;
(function (RecipientRuleParamIndex) {
    RecipientRuleParamIndex[RecipientRuleParamIndex["COLUMN"] = 0] = "COLUMN";
})(RecipientRuleParamIndex = exports.RecipientRuleParamIndex || (exports.RecipientRuleParamIndex = {}));
/** 電帳法チェックのパラメータのIndex */
var ErrlDpiRuleParamIndex;
(function (ErrlDpiRuleParamIndex) {
    ErrlDpiRuleParamIndex[ErrlDpiRuleParamIndex["DPI_COLUMN"] = 0] = "DPI_COLUMN";
    ErrlDpiRuleParamIndex[ErrlDpiRuleParamIndex["IS_SCANNED_DOCUMENT"] = 1] = "IS_SCANNED_DOCUMENT";
})(ErrlDpiRuleParamIndex = exports.ErrlDpiRuleParamIndex || (exports.ErrlDpiRuleParamIndex = {}));
/** 電帳法チェックのパラメータのIndex */
var ErrlDpiExistRuleParamIndex;
(function (ErrlDpiExistRuleParamIndex) {
    ErrlDpiExistRuleParamIndex[ErrlDpiExistRuleParamIndex["DPI_COLUMN"] = 0] = "DPI_COLUMN";
    ErrlDpiExistRuleParamIndex[ErrlDpiExistRuleParamIndex["IS_SCANNED_DOCUMENT"] = 1] = "IS_SCANNED_DOCUMENT";
})(ErrlDpiExistRuleParamIndex = exports.ErrlDpiExistRuleParamIndex || (exports.ErrlDpiExistRuleParamIndex = {}));
/** 電帳法チェックのパラメータのIndex */
var ErrlColorRuleParamIndex;
(function (ErrlColorRuleParamIndex) {
    ErrlColorRuleParamIndex[ErrlColorRuleParamIndex["COLOR_COLUMN"] = 0] = "COLOR_COLUMN";
    ErrlColorRuleParamIndex[ErrlColorRuleParamIndex["IS_SCANNED_DOCUMENT"] = 1] = "IS_SCANNED_DOCUMENT";
})(ErrlColorRuleParamIndex = exports.ErrlColorRuleParamIndex || (exports.ErrlColorRuleParamIndex = {}));
